export default __webpack_public_path__ + "static/media/468081__kinoton__egg-timer-ticking-ringing.9165614f.mp3";